import React from 'react';

export default function ReportPlacement() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Report Placement Jepang</h1>
      <p className="text-gray-500">Halaman Report Placement Jepang</p>
    </div>
  );
}
